import React from 'react'

export function FormError({ error, className = "" }) {
  // TODO Margin should maybe not belong here?
  return error ? (
    <p className={'mt-2 text-red-600 w-full ' + className}>{error}</p>
  ) : null
}
